// extracted by mini-css-extract-plugin
export default {"elapsed":"ElapsedTime_elapsed__cxdas"};